// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2m71k83E","inner":"_1pJtwysE","smooth":"vUU8NK5j","headlineXS":"_3o374khK","headlineSM":"_2lryTlRv","headlineMD":"_30mnCotj","headlineGTMD":"XnwcSLK0","subheadlineLarge":"GqzDWdQQ","subheadlineMedium":"_3IOameey","subheadlineSmall":"_2c6PoFsY"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/eye-catcher/eye-catcher.styles.scss
// module id = 747
// module chunks = 0